import { DELETE_CONDITIONAL_DISPLAY_TOPICS } from "../../../../constants";

export const deleteConditionBlockBasedOnHris = (payload, cb) => { 
    return (dispatch) => {
        dispatch({ type: DELETE_CONDITIONAL_DISPLAY_TOPICS, payload });
    }
};